module.exports = __webpack_public_path__ + "static/media/local-central-mobile.4c356965.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-central-mobile.png
// module id = 1180
// module chunks = 2